// True when a mail history/status record has a delivery message that isn't a success, i.e. the email bounced or failed. 2026-10-26
export function isMailFailed (record) {
  if (!record || !record.message) return false
  return !/sent successfully/i.test(record.message)
}



// WEBPACK FOOTER //
// ./src/utils/mailStatus.js